import { createFileRoute } from '@tanstack/react-router';

import ChecklistStage from '@/ui/pages/Installer/stages/checklist/ChecklistStage';

// HS-1637: stage 2 — the hardware checklist.
export const Route = createFileRoute('/_dashboard/installer/installations/$id/checklist')({
  component: ChecklistStage,
});
